import { useCallback, useRef } from 'react';

/**
 * 배경(딤)을 눌러 닫기 — 누르기 시작한 곳도 배경일 때만 닫습니다.
 *
 * 끝난 지점만 보면, 누르는 사이에 화면이 움직였을 때 내용 위에서 시작한 탭이
 * 배경에서 끝나며 창이 닫힙니다. 기기에서는 키보드가 내려가며 뷰포트가 커질 때
 * 자주 일어납니다 — 글을 쓰다 별점을 누르면 손가락은 별 위에 있었는데 그 자리가
 * 배경이 되어 있습니다.
 *
 * 돌려주는 것을 배경 요소에 그대로 펼쳐 붙입니다.
 *
 *     const backdrop = useBackdropClose(onClose);
 *     <div className={...} {...backdrop}>
 */
export const useBackdropClose = <T extends HTMLElement = HTMLDivElement>(
    onClose: () => void,
) => {
    const ref = useRef<T>(null);
    const startedOnBackdrop = useRef(false);

    const onPointerDown = useCallback((e: React.PointerEvent<T>) => {
        startedOnBackdrop.current = e.target === ref.current;
    }, []);

    const onClick = useCallback((e: React.MouseEvent<T>) => {
        if (!startedOnBackdrop.current) return;
        if (e.target !== ref.current) return;
        onClose();
    }, [onClose]);

    return { ref, onPointerDown, onClick };
};
